var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5H8C6.61929 12.5 5.5 13.6193 5.5 15C5.5 16.3807 6.61929 17.5 8 17.5H16C17.3807 17.5 18.5 16.3807 18.5 15C18.5 13.6193 17.3807 12.5 16 12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 11C12.8194 11 13.491 10.3284 13.491 9.5V1.5C13.491 0.671573 12.8194 0 11.991 0C11.1626 0 10.491 0.671573 10.491 1.5V9.5C10.491 10.3284 11.1626 11 11.991 11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 19H11.984C11.5862 19.0019 11.2054 19.1617 10.9254 19.4443C10.6454 19.7269 10.4891 20.1092 10.491 20.507L10.5 22.507C10.5039 23.3327 11.1743 24 12 24H12.007C12.835 23.9961 13.5033 23.322 13.5 22.494L13.491 20.494C13.4877 19.6679 12.8171 19 11.991 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFader);
export default __webpack_public_path__ + "static/media/fader.988a7a92.svg";
export { ForwardRef as ReactComponent };